// oxlint-disable eslint-plugin-react-hooks/exhaustive-deps
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function DatePicker({
  name,
  onFinish,
  onChange,
  autoFocus = true,
  value,
  disabled = false,
}: {
  name: string;
  onFinish?: (date: string) => void;
  onChange?: (date: string) => void;
  autoFocus?: boolean;
  value?: string;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const handleDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    (document.getElementById("yearInput") as HTMLInputElement | null)?.setCustomValidity("");
    const value = e.target.value;
    if (value.length <= 2) setDay(value);
    const nextInput = e.target.nextElementSibling?.nextElementSibling;
    if (value.length === 2 && isInputElement(nextInput)) {
      nextInput.focus();
    }
  };

  const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    (document.getElementById("yearInput") as HTMLInputElement | null)?.setCustomValidity("");
    const value = e.target.value;
    if (value.length <= 2) setMonth(value);
    const nextInput = e.target.nextElementSibling?.nextElementSibling;
    if (value.length === 2 && isInputElement(nextInput)) {
      nextInput.focus();
    }
  };

  const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.setCustomValidity("");
    const value = e.target.value;
    if (value.length <= 4) setYear(value);
  };

  const date = `${day.padStart(2, "0")}.${month.padStart(2, "0")}.${year}`;

  useEffect(() => {
    if (value?.length === 10) {
      const [day, month, year] = value.split(".");
      if (day) setDay(day);
      if (month) setMonth(month);
      if (year) setYear(year);
    }
  }, [value]);

  useEffect(() => {
    onChange?.(date);
    if (date.length === 10) {
      onFinish?.(date);
    }
  }, [date]);

  return (
    <>
      <div className="flex items-center justify-center gap-2">
        <input
          className="w-12 rounded-md border border-blue-300 px-2 py-4 text-center disabled:opacity-50"
          type="number"
          value={day}
          onChange={handleDayChange}
          placeholder={t("TT")}
          maxLength={2}
          minLength={2}
          autoFocus={autoFocus}
          min={1}
          max={31}
          disabled={disabled}
          onBlur={(e) => {
            const value = e.target.value;
            if (value.length === 1) setDay(day.padStart(2, "0"));
          }}
        />
        <span className="text-gray-400">.</span>
        <input
          className="w-12 rounded-md border border-blue-300 px-2 py-4 text-center disabled:opacity-50"
          type="number"
          value={month}
          onChange={handleMonthChange}
          placeholder={t("MM")}
          maxLength={2}
          minLength={2}
          size={2}
          min={1}
          max={12}
          disabled={disabled}
          onBlur={(e) => {
            const value = e.target.value;
            if (value.length === 1) setMonth(month.padStart(2, "0"));
          }}
        />
        <span className="text-gray-400">.</span>
        <input
          id="yearInput"
          className="w-20 rounded-md border border-blue-300 px-2 py-4 text-center disabled:opacity-50"
          type="number"
          value={year}
          onChange={handleYearChange}
          placeholder={t("JJJJ")}
          maxLength={4}
          size={4}
          minLength={4}
          max={new Date().getFullYear()}
          min={1900}
          required={true}
          disabled={disabled}
        />
      </div>
      <input type="hidden" value={date} name={name} />
    </>
  );
}

function isInputElement(e: Element | undefined | null): e is HTMLInputElement {
  return e?.tagName === "INPUT";
}
